import React, { useState } from "react";

const morse = {
    "A": ".-", "B": "-...", "C": "-.-.", "D": "-..", "E": ".",
    "F": "..-.", "G": "--.", "H": "....", "I": "..", "J": ".---",
    "K": "-.-", "L": ".-..", "M": "--", "N": "-.", "O": "---",
    "P": ".--.", "Q": "--.-", "R": ".-.", "S": "...", "T": "-",
    "U": "..-", "V": "...-", "W": ".--", "X": "-..-", "Y": "-.--", "Z": "--.."
};

const words = ["CODE", "DATA", "TECH", "BYTE", "WIFI"];

export default function MorseTrainer() {
    const [word, setWord] = useState(words[0]);
    const [answer, setAnswer] = useState("");
    const [score, setScore] = useState(0);
    const [wordIndex, setWordIndex] = useState(0);
    const [done, setDone] = useState(false);
    const [started, setStarted] = useState(false);

    const getMorse = (w) => w.split("").map(c => morse[c]).join(" / ");

    const check = () => {
        if (answer.toUpperCase() === word) {
            setScore(score + 1);
            if (wordIndex + 1 < words.length) {
                setWordIndex(wordIndex + 1);
                setWord(words[wordIndex + 1]);
                setAnswer("");
            } else {
                setDone(true);
            }
        }
    };

    if (!started) {
        return (
            <div style={{textAlign:"center",padding:"1rem",color:"#e5e7eb",background:"rgba(255,255,255,0.05)",borderRadius:"1rem",boxShadow:"0 0 25px rgba(0,255,200,0.15)"}}>
                <h4 style={{color:"#facc15",marginBottom:"0.5rem"}}>
                    <i className="fas fa-signal" style={{marginRight:"6px"}}></i> Morse Trainer
                </h4>
                <p style={{fontSize:"0.85rem",marginBottom:"1rem"}}>Traduci dal codice Morse!</p>
                <button onClick={() => setStarted(true)} style={{background:"linear-gradient(135deg,#facc15,#ca8a04)",border:"none",color:"#000",fontWeight:"700",padding:"0.6rem 1.2rem",borderRadius:"0.5rem",cursor:"pointer"}}>
                    <i className="fas fa-play" style={{marginRight:"6px"}}></i> Inizia
                </button>
            </div>
        );
    }

    if (done) {
        return (
            <div style={{textAlign:"center",padding:"1.5rem",color:"#e5e7eb",background:"rgba(255,255,255,0.05)",borderRadius:"1rem",boxShadow:"0 0 25px rgba(0,255,200,0.15)"}}>
                <h4 style={{color:"#facc15",marginBottom:"1rem"}}>
                    <i className="fas fa-trophy" style={{marginRight:"6px"}}></i> Completato!
                </h4>
                <p style={{fontSize:"1.5rem",fontWeight:"700",color:"#22c55e",marginBottom:"1rem"}}>
                    {score}/{words.length}
                </p>
                <button onClick={() => {setStarted(true);setWordIndex(0);setWord(words[0]);setScore(0);setDone(false);setAnswer("");}} style={{background:"linear-gradient(135deg,#16a34a,#065f46)",border:"none",color:"#fff",fontWeight:"700",padding:"0.6rem 1.2rem",borderRadius:"0.5rem",cursor:"pointer"}}>
                    <i className="fas fa-redo" style={{marginRight:"6px"}}></i> Rigioca
                </button>
            </div>
        );
    }

    return (
        <div style={{textAlign:"center",padding:"1.5rem",color:"#e5e7eb",background:"rgba(255,255,255,0.05)",borderRadius:"1rem",boxShadow:"0 0 25px rgba(0,255,200,0.15)"}}>
            <div style={{marginBottom:"1rem",color:"#94a3b8",fontSize:"0.85rem"}}>
                Parola {wordIndex + 1} di {words.length} - Punteggio: {score}
            </div>
            <div style={{fontSize:"1.5rem",fontWeight:"700",color:"#facc15",marginBottom:"1.5rem",fontFamily:"monospace",letterSpacing:"0.2rem"}}>
                {getMorse(word)}
            </div>
            <input type="text" value={answer} onChange={(e) => setAnswer(e.target.value)} onKeyPress={(e) => e.key === "Enter" && answer && check()}
                   style={{width:"100%",padding:"0.8rem",borderRadius:"0.5rem",border:"2px solid rgba(255,255,255,0.1)",background:"rgba(255,255,255,0.05)",color:"#fff",fontSize:"1.2rem",textAlign:"center",outline:"none",marginBottom:"1rem"}}
                   placeholder="TRADUCI..." />
            <button onClick={check} disabled={!answer} style={{background:answer?"linear-gradient(135deg,#2563eb,#1e40af)":"rgba(255,255,255,0.1)",border:"none",color:"#fff",fontWeight:"700",padding:"0.6rem 1.2rem",borderRadius:"0.5rem",cursor:answer?"pointer":"not-allowed",opacity:answer?1:0.5,width:"100%"}}>
                <i className="fas fa-check" style={{marginRight:"6px"}}></i> Verifica
            </button>
        </div>
    );
}